<template>
    <div>

        <div style="margin-bottom: 1rem">
            <el-button size="mini" @click="openAddDialog" type="primary">添加</el-button>
        </div>

        <el-table
            :data="tableData"
            stripe
            style="width: 100%">
            <el-table-column
                prop="id"
                label="ID"
                width="80">
            </el-table-column>
            <el-table-column
                prop="email"
                label="账号">
            </el-table-column>
            <el-table-column
                prop="client_id"
                label="Client ID">
                <template slot-scope="scope">
                    <span style="font-family: monospace; color: #909399;font-size: 11px;">{{ scope.row.client_id }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="secret_id"
                label="Secret ID">
                <template slot-scope="scope">
                    <span style="font-family: monospace; color: #909399;font-size: 11px;">{{ scope.row.secret_id }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="webhook_id"
                label="Webhook ID"
                width="180">
            </el-table-column>
            <el-table-column
                prop="created_at"
                label="添加时间"
                width="130">
                <template slot-scope="scope">
                    {{ $moment(scope.row.created_at).format("YYYY-MM-DD") }}
                    <br>{{ $moment(scope.row.created_at).format("HH:mm:ss") }}
                </template>
            </el-table-column>
            <el-table-column
                prop="updated_at"
                label="修改时间"
                width="130">
                <template slot-scope="scope">
                    {{ $moment(scope.row.updated_at).format("YYYY-MM-DD") }}
                    <br>{{ $moment(scope.row.updated_at).format("HH:mm:ss") }}
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                width="180">
                <template slot-scope="scope">
                    <el-button size="mini" @click="editPayment(scope.row)" type="primary">编辑</el-button>
                    <el-button size="mini" @click="deletePayment(scope.row)" type="danger">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="current_page"
            :page-size="per_page"
            :page-sizes="[20, 30, 50,100]"
            :pager-count="11"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>

        <!-- Form -->
        <el-dialog :title="isEdit ? '编辑支付信息' : '添加支付信息'" :visible.sync="dialogFormVisible">
            <div v-if="isEdit" style="background: #f5f7fa; padding: 10px; margin-bottom: 15px; border-radius: 4px; font-size: 12px; color: #606266;">
                <i class="el-icon-info"></i> 提示：Client ID、Secret ID、Webhook ID 留空将保持原有值不变。表格中显示的是脱敏数据，实际存储的是完整信息。
            </div>
            <el-form :model="form" ref="paymentForm">
                <el-form-item label="账号" prop="email">
                    <el-input v-model="form.email" autocomplete="off" placeholder="请输入邮箱账号"></el-input>
                </el-form-item>
                <el-form-item label="Client ID" prop="client_id">
                    <el-input v-model="form.client_id" autocomplete="off" 
                        :placeholder="isEdit ? `留空保持原值: ${maskedData.client_id}` : '请输入Client ID'"></el-input>
                </el-form-item>
                <el-form-item label="Secret ID" prop="secret_id">
                    <el-input v-model="form.secret_id" autocomplete="off" 
                        :placeholder="isEdit ? `留空保持原值: ${maskedData.secret_id}` : '请输入Secret ID'"></el-input>
                </el-form-item>
                <el-form-item label="Webhook ID" prop="webhook_id">
                    <el-input v-model="form.webhook_id" autocomplete="off" 
                        :placeholder="isEdit ? '留空保持原值' : '请输入Webhook ID'"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelDialog">取 消</el-button>
                <el-button type="primary" @click="submit">{{ isEdit ? '更新' : '添加' }}</el-button>
            </div>
        </el-dialog>


    </div>


</template>

<script>

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18

Date.prototype.Format = function (fmt) { // author: meizz
    var o = {
        "M+": this.getMonth() + 1, // 月份
        "d+": this.getDate(), // 日
        "h+": this.getHours(), // 小时
        "m+": this.getMinutes(), // 分
        "s+": this.getSeconds(), // 秒
        "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
        "S": this.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

export default {
    name: "Index",
    data() {
        return {
            current_page: 1,//当前页
            per_page: 20,//每页数量
            total: 0,//总数

            tableData: [],

            dialogFormVisible: false,
            isEdit: false, // 是否为编辑模式
            editId: null, // 当前编辑的记录ID

            form: {
                email: "",
                client_id: "",
                secret_id: "",
                webhook_id: ""
            },
            
            // 存储当前编辑记录的脱敏数据，用于placeholder显示
            maskedData: {
                client_id: "",
                secret_id: ""
            }

        }
    },
    methods: {

        setSubmit() {
            this.getTableData(1, this.per_page)
        },

        // 获取表格数据
        getTableData(page, limit) {

            let param = {
                page: page,
                limit: limit,
            };

            console.log(param)

            this.http.fetchGet(this.api.payment_list, param).then((res) => {
                if (res.data.code === 200) {
                    let data = res.data.data;
                    console.log(data)

                    this.total = data.total;
                    this.current_page = data.current_page;

                    this.tableData = data.data
                }
                if (res.data.code === 201) {
                    let url = res.data.data.url;
                    window.open(url)
                }

            }).catch(err => {
                console.log(err)
            })
        },

        //分页改变...
        handleCurrentChange(val) {
            // this.current_page=val
            this.getTableData(val, this.per_page)
        },
        handleSizeChange(val) {

            this.per_page = val;
            //返回第一页
            this.handleCurrentChange(1);
        },

        // 打开添加对话框
        openAddDialog() {
            this.isEdit = false;
            this.editId = null;
            this.resetForm();
            this.dialogFormVisible = true;
        },

        // 编辑支付信息
        editPayment(row) {
            this.isEdit = true;
            this.editId = row.id;
            this.form.email = row.email;
            // 出于安全考虑，敏感信息不显示原值，留空表示保持原值
            this.form.client_id = '';
            this.form.secret_id = '';
            // 存储脱敏数据用于placeholder显示
            this.maskedData.client_id = row.client_id || '';
            this.maskedData.secret_id = row.secret_id || '';
            // Webhook ID 显示原值，用户可选择修改或清空（清空表示保持原值）
            this.form.webhook_id = row.webhook_id || '';
            this.dialogFormVisible = true;
        },

        // 删除支付信息
        deletePayment(row) {
            this.$confirm('确定要删除这条支付信息吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.http.fetchDel(this.api.payment_delete.replace(':id', row.id)).then((res) => {
                    if (res.data.code === 200) {
                        this.$message.success('删除成功');
                        this.getTableData(this.current_page, this.per_page);
                    } else {
                        this.$message.error(res.data.message || '删除失败');
                    }
                }).catch(err => {
                    console.log(err);
                    this.$message.error('删除失败');
                });
            });
        },

        // 重置表单
        resetForm() {
            this.form = {
                email: "",
                client_id: "",
                secret_id: "",
                webhook_id: ""
            };
            // 重置脱敏数据
            this.maskedData = {
                client_id: "",
                secret_id: ""
            };
        },

        // 取消对话框
        cancelDialog() {
            this.dialogFormVisible = false;
            this.resetForm();
        },

        // 提交表单（添加/编辑）
        submit() {
            if (this.isEdit) {
                // 编辑模式
                this.http.fetchPut(this.api.payment_update.replace(':id', this.editId), this.form).then((res) => {
                    var data = res.data;
                    if (data.code === 200) {
                        this.$message.success('更新成功');
                        this.dialogFormVisible = false;
                        this.getTableData(this.current_page, this.per_page);
                        this.resetForm();
                    } else {
                        this.$message.error(data.message || '更新失败');
                    }
                }).catch(err => {
                    console.log(err);
                    this.$message.error('更新失败');
                });
            } else {
                // 添加模式
                this.http.fetchPost(this.api.payment_create, this.form).then((res) => {
                    var data = res.data;
                    if (data.code === 200) {
                        this.$message.success('添加成功');
                        this.dialogFormVisible = false;
                        this.getTableData(1, this.per_page);
                        this.resetForm();
                    } else {
                        this.$message.error(data.message || '添加失败');
                    }
                }).catch(err => {
                    console.log(err);
                    this.$message.error('添加失败');
                });
            }
        }

    },
    mounted(){
        this.getTableData(this.current_page,this.per_page)
    }
}
</script>

<style scoped lang="stylus">
.header-checkbox
    //text-align center
    margin .5rem 0

.el-radio-group
    display block
    margin-bottom 1rem
</style>
